import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Invoice} from '../../core/_models'
import {API_URL, PosPayment, numberWithCommas} from '../../../../../../../_metronic/helpers'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import axios from 'axios'

type Props = {
  invoice: Invoice
  setShowPaymentModal: Dispatch<SetStateAction<boolean>>
}

const PaymentPos: FC<Props> = ({invoice, setShowPaymentModal}) => {
  const [price, setPrice] = useState('')
  const pay = (prc: number) => {
    setShowPaymentModal(false)
    axios.post(`${API_URL}/payment/pos`, {price: prc, hash: invoice.hsh}).then((response) => {
      PosPayment(prc.toString(), response.data)
    })
  }

  useEffect(() => {
    if (Number(price) > (invoice.pymr || 0)) {
      setPrice((invoice.pymr || 0).toString())
    }
    if (Number(price) < 0) {
      setPrice('0')
    }
  }, [price])

  return (
    <>
      <div
        className='border border-1 border-primary border-dashed rounded my-5 bg-light-primary p-3 text-center fs-3x text-primary'
        onClick={() => {
          pay(invoice.pymr || 0)
        }}
      >
        {numberWithCommas(invoice.pymr)} <span className='fs-5 text-gray-500'>ریال</span>
      </div>
      {(invoice.pymr || 0) > 2000000000 && (
        <div
          className='border border-1 border-primary border-dashed rounded my-5 bg-light-primary p-3 text-center fs-3x text-primary'
          onClick={() => {
            pay(2000000000)
          }}
        >
          {numberWithCommas(2000000000)} <span className='fs-5 text-gray-500'>ریال</span>
        </div>
      )}
      <div className='separator separator-dashed border-gray-500 mb-10'></div>
      <div>
        <CustomInputs
          type={'currency'}
          label={'مبلغ'}
          stateValue={{value: price, setValue: setPrice}}
        />
        <button
          className='btn btn-success w-100 mt-5'
          onClick={() => {
            pay(Number(price))
          }}
        >
          پرداخت
        </button>
      </div>
    </>
  )
}

export {PaymentPos}
